import React from 'react';
import { renderIf, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import NumberFormat from 'react-number-format';

function BaasicTimeInputTemplate({ field, t, placeholder, ...props }) {
	const { additionalInfo, className } = props;
	if (placeholder) {
		placeholder = t(placeholder);
	}
	const showCheckmark = isSome(props.showCheckmark) ? props.showCheckmark : true;
	const validation = isSome(props.validation) ? props.validation : true;
	const requiredMark =
		field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;

	return (
		<div className={`spc--bottom--sml ${className}`}>
			<label htmlFor={field.id} className="form__label--required">
				{`${t(field.label)}${isSome(additionalInfo) ? additionalInfo : ''}`} {requiredMark}
			</label>
			{renderIf(isSome(field.error) && validation)(<p className="type--tny type--color--error">{t(field.error)}</p>)}
			<div className="pos--rel">
				<NumberFormat
					className={
						isSome(field.error) && validation
							? 'input input--med input--text input--invalid'
							: showCheckmark &&
							  field.$rules &&
							  field.$rules.includes('required') &&
							  !isSome(field.error) &&
							  field.$value
							? 'input input--med input--text input__wrap--valid'
							: 'input input--med input--text'
					}
					{...field.bind()}
					{...props}
				/>
				{renderIf(
					showCheckmark && field.$rules && field.$rules.includes('required') && !isSome(field.error) && field.$value
				)(
					<span className="form__label--check type--color--success">
						<i className="fa fa-check-circle"></i>
					</span>
				)}
			</div>
		</div>
	);
}

export default defaultTemplate(BaasicTimeInputTemplate);
